var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.autostarttoken)?_c('div',{staticClass:"container"},[_c('img',{staticClass:"logo",attrs:{"src":require('@/assets/images/BankID_MasterBrand/BankID_logo_black.png'),"alt":"Logo"}}),_c('memlist-button',{attrs:{"size":'large',"title":_vm.$t('BANKID.OPEN_BANKID')},on:{"clicked":_vm.open_bankid_clicked}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }